import { useNavigate } from 'react-router-dom';
import './Menu.scss';
import { useContext } from 'react';
import { UserContext } from '../../js/UserContext';

const Menu = ({ title, subtitle = null, options }) => {
    const navigate = useNavigate();
    const { user, loading } = useContext(UserContext);
    if (loading) {
        return <p>Loading...</p>;
    }

    return (
        <div id='menu'>
            <div className="menu-container">
                <h1 className="menu-title">{title}</h1>
                { subtitle && <h2 className="menu-subtitle">{subtitle}</h2> }
                <ul className="menu-options">
                    {options
                    .filter(o => !o.visible || o.visible({ user }))
                    .map((option, index) => (
                        <li className="menu-option" key={index} onClick={(e) => {
                            e.preventDefault();
                            if (option.path === '..' || option.path === '/..') {
                                navigate(-1);
                            } else if (option.path) {
                                navigate(option.path, option.state_ ? { state: option.state_ } : {});
                            } else if (option.onClick) {
                                option.onClick(e);
                            }
                        }}>
                            {option.name}
                            {option.subname && <div className="menu-option-subname">{option.subname}</div>}
                        </li>
                    ))}
                </ul>
            </div>
        </div>
    );
};

export default Menu;